import { takeUntil } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store'

import { Observable } from 'rxjs'

import * as account from '../../actions/account'
import * as fromAuth from '../../reducers'
import * as status from '../../../base/actions/status.actions';

import { ContainerBase } from '../../../core/base/container-base';

@Component({
  selector: 'app-reset-account-container',
  templateUrl: './template.html'
})
export class ForgotAccountContainer extends ContainerBase implements OnInit {
  resetting$: Observable<boolean>
  error$: Observable<any>

  constructor(
    private store: Store<fromAuth.State>
  ) {
    super()

    this.error$ = store.pipe(select(fromAuth.getResetError), takeUntil(this.destroyed$))
    this.resetting$ = store.pipe(select(fromAuth.isResetting), takeUntil(this.destroyed$))

    // remove header space
    this.store.dispatch(new status.SetHeader(false));

  }

  ngOnInit() {
    this.store.dispatch(new account.ForgotClear())
  }

  submitReset(event: { email: string }) {
    this.store.dispatch(new account.Forgot(event.email))
  }
}
